import adapter from '../adapter-programs-component';
var IDs = adapter.IDs, SchemaTypes = adapter.SchemaTypes;
export default {
    type: SchemaTypes.PROGRAMS_COMPONENT_COURSE_LIST,
    schema: "{{".concat(IDs.SD_JSON_PROGRAMS, "}}"),
};
